/* Core & libraries */
import React, {useEffect, useState} from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";

/* Helpers, constants, custom methods, internal libraries */
import { useUserContext } from "../../../contexts/userContext";
import { useGeneralService } from "../../../services/generalService";
import { toReversedHelper } from "../../../helpers/general.js";
import { AIRLINES } from "../../../constants/appConstants";

/* Components */
import UserProfileAA from "../../userProfile/AA"
import PersonalProfileAA from "../../personalProfile/AA"
import UserProfileUC from "../../userProfile/UC"
import PersonalProfileUC from "../../personalProfile/UC"
import UserProfileAS from "../../userProfile/AS"
import PersonalProfileAS from "../../personalProfile/AS"
import UserProfileAM from "../../userProfile/AM"
import PersonalProfileAM from "../../personalProfile/AM"
import ProfileSkeleton from "../../skeletonStructureProfile";
import UserProfileCHOICE from '../../userProfile/CHOICE';
import PersonalProfileCHOICE from '../../personalProfile/CHOICE';
import PersonalProfileAC from '../../personalProfile/AC';
import UserProfileAC from '../../userProfile/AC';

/* Styles */
import styles from "./styles.js"


const ProfileTab = ({travelerDetails, refetchTravelerDetails}) => {
  const theme = useTheme();
  const classes = styles({theme});

  const [roles, setRoles] = useState(null);
  const [teams, setTeams] = useState(null);
  const userDetails = useUserContext();
  const providerCode = userDetails?.userInfo?.providerInfo?.providerCode;

  const { getRoles, getTeams } = useGeneralService();

  useEffect(() => {
    (async () => {
      const responseRoles = await getRoles();
      if (responseRoles) {
        let rolesArray = [];
        let rolesArrReversed = toReversedHelper(responseRoles?.roles)

        rolesArrReversed?.map(roleId => {
          rolesArray.push({roleId: roleId, roleName: <FormattedMessage id={`roles.${roleId}.${providerCode}`} />})
        })
        setRoles(rolesArray);
      } else {
        setRoles([])
      }
      const responseTeams = await getTeams();
      if (responseTeams) {
        setTeams(responseTeams.managedgroups);
      } else {
        setTeams([])
      }
    })();
  }, []);

  const renderProfileTab = () => {
    switch (providerCode) {
      case AIRLINES.AA:
        return (
          <>
            {travelerDetails?.userEntityId === userDetails?.userInfo?.userEntityId ?
              <PersonalProfileAA travelerDetails={travelerDetails} roles={roles} teams={teams}/> :
              <UserProfileAA travelerDetails={travelerDetails} roles={roles} teams={teams}/> }
          </>
        );
      case AIRLINES.UC:
        return (
          <>
            {travelerDetails?.userEntityId === userDetails?.userInfo?.userEntityId ?
              <PersonalProfileUC travelerDetails={travelerDetails} roles={roles} teams={teams} refetchTravelerDetails={refetchTravelerDetails}/> :
              <UserProfileUC travelerDetails={travelerDetails} roles={roles} teams={teams} refetchTravelerDetails={refetchTravelerDetails}/> }
          </>
        );
      case AIRLINES.AS:
        return (
          <>
            {travelerDetails?.userEntityId === userDetails?.userInfo?.userEntityId ?
              <PersonalProfileAS travelerDetails={travelerDetails} roles={roles} teams={teams}/> :
              <UserProfileAS travelerDetails={travelerDetails} roles={roles} teams={teams}/> }
          </>
        );
      case AIRLINES.AM:
        return (
          <>
            {travelerDetails?.userEntityId === userDetails?.userInfo?.userEntityId ?
              <PersonalProfileAM travelerDetails={travelerDetails} roles={roles} teams={teams}/> :
              <UserProfileAM travelerDetails={travelerDetails} roles={roles} teams={teams}/> }
          </>
        );

      case AIRLINES.AC:
        return (
          <>
            {travelerDetails?.userEntityId === userDetails?.userInfo?.userEntityId ?
              <PersonalProfileAC travelerDetails={travelerDetails} roles={roles} teams={teams} refetchTravelerDetails={ refetchTravelerDetails }/> :
              <UserProfileAC travelerDetails={travelerDetails} roles={roles} teams={teams} refetchTravelerDetails={ refetchTravelerDetails }/> }
          </>
        );

      case AIRLINES.CHOICE:
        return (
          <>
            {travelerDetails?.userEntityId === userDetails?.userInfo?.userEntityId ?
              <PersonalProfileCHOICE travelerDetails={travelerDetails} roles={roles} teams={teams} refetchTravelerDetails={ refetchTravelerDetails }/> :
              <UserProfileCHOICE travelerDetails={travelerDetails} roles={roles} teams={teams} refetchTravelerDetails={ refetchTravelerDetails }/> }
          </>
        );

    }
  }

  return (
    travelerDetails &&
    <div>
      <div className={classes.details}>
        <div>
          <div className={classes.title}>
            <FormattedMessage id={`traveler.details.title.${providerCode}`}/>
          </div>
          <div className={classes.subtitle}>
            <FormattedMessage id={`traveler.details.subtitle`}/>
          </div>
        </div>
      </div>
      <div className={classes.dividerContainer}>
        <hr className={classes.border}/>
      </div>
      {!travelerDetails?.companyInfo || roles === null || teams === null ? (
          <ProfileSkeleton />
       ) : (
          renderProfileTab()
      )}
    </div>
  )
}

export default ProfileTab;
